import type { Locale } from '@seek/melways-sites';
import { useSelector } from 'src/store/react';
import { selectCountry, selectLanguage } from 'src/store/selectors';

export const useSelectedLocale = (): Locale => {
  const country = useSelector(selectCountry);
  const language = useSelector(selectLanguage);

  return `${language}-${country}` as Locale;
};
